// Local calendar date, not UTC — toISOString() would roll the date forward/back
// for timezones off UTC and misplace the "today" marker and range boundaries.
export const toISODate = (d) => {
	const y = d.getFullYear();
	const m = String(d.getMonth() + 1).padStart(2, "0");
	const day = String(d.getDate()).padStart(2, "0");
	return `${y}-${m}-${day}`;
};
export const isSameDay = (a, b) => Boolean(a) && Boolean(b) && toISODate(a) === toISODate(b);
export const startOfMonth = (d) => new Date(d.getFullYear(), d.getMonth(), 1);
export const addMonths = (d, n) => new Date(d.getFullYear(), d.getMonth() + n, 1);

export const buildMonthCells = (monthDate) => {
	const first = startOfMonth(monthDate);
	const leading = first.getDay(); // 0=Sun
	const daysInMonth = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0).getDate();
	const cells = [];
	for (let i = 0; i < leading; i++) cells.push(null);
	for (let d = 1; d <= daysInMonth; d++) cells.push(new Date(monthDate.getFullYear(), monthDate.getMonth(), d));
	return cells;
};

export const isInRange = (day, start, end) => {
	if (!day || !start || !end) return false;
	return day >= start && day <= end;
};
